import styled from '@emotion/styled';
import {Icon} from '@bosch/react-frok';

export interface ThumbnailPlaceholderContainerProps {
    readonly isFolder: boolean;
}

export const ThumbnailPlaceholderContainer = styled.div<ThumbnailPlaceholderContainerProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    align-items: center;
    background-color: var(${(props) => (props.isFolder ? '--background' : '--major-accent__enabled__fill__default')});
    color: var(${(props) => (props.isFolder ? '--plain__enabled__front__default' : '--major-accent__enabled__front__default')});
`;

export const ThumbImage = styled(Icon)`
    font-size: 4rem;
`;

export const ThumbDescription = styled.div`
    margin-top: 1rem;
    text-align: center;
`;
